import { Provider } from '@angular/core';

import { IsGuardsAvailableService } from '../Domain/Port/is-guards-available.service';
import { AnalyticsGuardsAvailableServiceDecorator } from '../Infrastructure/Adapter/analytics-guards-available.service.decorator';

/**
 * Function to provide the GuardService as an array of providers
 */
export const provideIsGuardAvailableService = (): Provider[] => {
    return [
        {
            provide: IsGuardsAvailableService,
            useExisting: AnalyticsGuardsAvailableServiceDecorator
        }
    ];
};
